<template>
  <div
    class="nav-top"
    :class="{
      'is-active-database': nameWithoutPrefix(activePage),
      'signout-dropdown-close': !isSignOutDropdownVisible,
    }"
  >
    <div
      class="nav-top-left-wrapper"
      :class="{ isLeftNavbarVisible: isLeftNavbarVisible }"
    >
      <div
        class="nav-toggle"
        @click="openLeftNav"
        :style="{
          opacity: getHamBurgerIconOpacity,
        }"
        :class="{ 'in-work-flow': activePage === 'process-list' }"
      >
        <a class="icon">
          <div></div>
          <div></div>
          <div></div>
        </a>
      </div>
      <div
        class="logo-wrapper"
        @click="
          goTo(
            'data',
            customUserNavItems.length
              ? customUserNavItems[0].name
              : 'noDatabases'
          )
        "
        :class="{ 'in-work-flow': activePage === 'process-list' }"
        v-if="!isLeftNavbarVisible || activeSection == 'flows'"
      >
        <div class="logo fade-in">
          <img src="../assets/logo.svg" />
        </div>
      </div>
    </div>
    <div class="nav-top-right-wrapper" :data-text="activeDatabase.caption">
      <div class="menu1-bar">
        <div class="left-topmenu-wrap">
          <ul class="list-menu">
            <li
              class="list-item"
              @click="
                goTo(
                  'data',
                  customUserNavItems.length
                    ? customUserNavItems[0].name
                    : 'noDatabases'
                )
              "
              :class="{ active: activeSection == 'data' }"
            >
              <a
                ><img src="../assets/img/database-light.svg" /><span
                  >Daten</span
                ></a
              >
            </li>
            <li
              class="list-item"
              @click="goTo('flows', 'process-list')"
              :class="{ active: activeSection == 'flows' }"
            >
              <a
                ><img src="../assets/img/workflow-icon.svg" /><span
                  >Workflows</span
                ></a
              >
            </li>
          </ul>
        </div>
      </div>

      <b-dropdown
        @show="toggleSignOutDropdown(true)"
        @hide="toggleSignOutDropdown(false)"
        class="signout-dropdown"
        right
        :text="userName?.toUpperCase()"
      >
        <b-dropdown-text class="signout-username">
          {{ userName?.toUpperCase() }}
        </b-dropdown-text>
        <b-dropdown-text class="signout-email">
          {{ userEmail }}
        </b-dropdown-text>
        <b-dropdown-text class="signout-text"
          ><amplify-sign-out v-if="user"></amplify-sign-out
        ></b-dropdown-text>
      </b-dropdown>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '../store/store';

export default {
  name: 'Navbar',
  data() {
    return {
      showMore: false,
      showNewDataType: false,
      isConfirmationModalVisible: false,
      hasCustomAddNewPermission: false,
      topNavMarginToLeft: 430,
      isSignOutDropdownVisible: false,
    };
  },
  props: {
    customUserNavItems: Array,
    activeDatabase: Object,
    isLeftNavbarVisible: Boolean,
  },
  methods: {
    toggleList: function () {
      this.showMore = !this.showMore;
    },
    showList: function () {
      this.showMore = true;
    },
    hideList: function () {
      this.showMore = false;
    },
    getTitle: function () {
      if (this.$route.params.title) return this.$route.params.title;
      else return this.appSettings('title');
    },
    shareDatabase: async function (dataBase) {
      if (this.activeDatabase.name != dataBase)
        await this.goTo('data', dataBase);
      this.$emit('toggleShareDatabase', dataBase);
    },
    removeDatabase: async function (dataBase) {
      if (this.activeDatabase.name != dataBase)
        await this.goTo('data', dataBase);
      this.$emit('toggleRemoveDatabase', dataBase);
    },
    leaveDatabase: async function (dataBase) {
      if (this.activeDatabase.name != dataBase)
        await this.goTo('data', dataBase);
      this.$emit('toggleLeaveDatabase', dataBase);
    },
    editDatabase: async function (dataBase) {
      if (this.activeDatabase.name != dataBase)
        await this.goTo('data', dataBase);
      this.$emit('toggleEditDatabaseSchema', dataBase);
    },
    goTo: async function (section, database = null, processId) {
      let prop = database ? 'database' : 'processId';
      let val = database ? database : processId;

      let rslt = await this.$router.push({
        path: '/',
        query: { section: section, [prop]: val },
      });
      return rslt;
    },
    getUserCustomDatabases: function () {
      var url = process.env.VUE_APP_DATA_API;
      url += '/user-tables';

      // API headers
      var myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      return fetch(url, {
        headers: myHeaders,
        method: 'GET',
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          this.customUserNavItems = json;
        });
    },
    toggleNewDataType: function () {
      this.$emit('toggleNewDataType');
    },
    nameWithoutPrefix: function (name) {
      return name?.split('_').slice(1).join('_');
    },
    userHasTableEditPermission: function (accessLevel) {
      let editPermissions = ['full_access', 'owner'];
      if (editPermissions.includes(accessLevel)) return true;
      else return false;
    },
    openLeftNav() {
      const updatedUserSettings = {
        ...this.userSettings,
        isShowLeftNavbar: true,
      };
      store.commit('setUserSettingsDB', updatedUserSettings);
      store.dispatch('putUserSettings', { settings: updatedUserSettings });
      this.$emit('toggleLeftNavbar', true);
    },
    toggleSignOutDropdown(value) {
      if (value != this.isSignOutDropdownVisible)
        this.isSignOutDropdownVisible = value;
    },
  },
  created() {
    if (this.userSettings) {
      this.topNavMarginToLeft = !this.userSettings.leftNavbarWidth
        ? 420
        : this.userSettings.leftNavbarWidth;
    }
  },
  computed: {
    ...mapGetters({ userName: 'getUserName', userEmail: 'getUserEmail' }),
    user() {
      return store.state.user;
    },
    isAdmin() {
      return store.state.isAdmin;
    },
    activePage() {
      return this.$route.query.database;
    },
    activeSection() {
      return this.$route.query.section;
    },
    userSettings() {
      return store.state?.userSettings;
    },
    getHamBurgerIconOpacity() {
      return !this.isLeftNavbarVisible && this.activePage != 'process-list'
        ? 1
        : 0;
    },
  },
  watch: {
    userSettings: function (values) {
      if (values) this.topNavMarginToLeft = values.leftNavbarWidth + 10;
    },
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
};
</script>

<style>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
@import 'https://fonts.googleapis.com/css?family=Hammersmith+One|Nunito|Orbitron:500|Poiret+One';

.nav-top * {
  box-sizing: border-box;
}
.nav-top {
  background-color: #1f2532;
  color: #f3f7ea;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 17px 45px;
  box-sizing: border-box;
  height: 80px;
}

.nav-top-left {
  display: flex;
  align-items: center;
}

.menu1-bar {
  text-transform: uppercase;
  font-size: 10px;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 55px;
}
.nav-top .menu1-bar .list-item.active {
  font-weight: 500;
  color: #fff;
}
.menu1-bar a::selection {
  background: transparent;
}

.menu1-bar .list-menu {
  height: auto;
  padding: 0;
  margin: 0;
}

.menu2-bar a::selection {
  background: transparent;
}
.menu2-bar a::selection {
  background: transparent;
}

.fade-in {
  animation: fadeIn ease 1s;
  -webkit-animation: fadeIn ease 1s;
  -moz-animation: fadeIn ease 1s;
  -o-animation: fadeIn ease 1s;
  -ms-animation: fadeIn ease 1s;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.nav-top .logo-wrapper {
  display: flex;
  width: auto;
  margin: 0;
  padding: 0;
  cursor: pointer;
  float: none;
  height: auto;
}

.nav-top .logo {
  padding: 0;
  margin: 0;
}

.logo img {
  width: 55px;
}

.title {
  float: left;
  margin: 0 20px 0 0;
  font-size: 33px;
  padding-right: 23px;
  line-height: 33px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  font-family: 'Nunito', sans-serif;
  color: white;
}

.nav-top ul li {
  list-style: none;
  display: inline-block;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: #9aa4b3;
}

.nav-top ul li img {
  height: 19px;
  margin-right: 13px;
  opacity: 0.5;
}

.nav-top ul {
  padding: 0;
  margin: 0;
}

.nav-top ul li a {
  text-decoration: none;
  display: block;
}

.nav-top ul li a.active {
  padding: 0;
  margin: 0;
  margin-left: 75px;
  display: block;
}

.nav-top .menu1-bar .list-item.active img {
  opacity: 1;
}

.nav-top ul li a:hover {
  color: #ffff;
}

.nav-top ul li a:visited {
  color: #9aa4b3;
  text-decoration: none;
}

.signout-dropdown ul li:last-child {
  border-top: 1px solid #eee;
  display: inline-block;
  width: 100%;
  padding-top: 15px;
  padding-bottom: 14px;
}

.signout-dropdown ul .signout-username {
  line-height: normal;
  user-select: none;
}

.signout-dropdown .dropdown-menu {
  padding: 35px 35px 10px;
}

.signout-dropdown .dropdown-menu .signout-username p {
  font-size: 18px;
  color: #000;
  font-weight: 800;
  padding: 0;
  user-select: none;
}

.signout-dropdown .dropdown-menu .signout-email p {
  padding: 0;
  margin-bottom: 30px;
  font-size: 15px;
  user-select: none;
}

.signout-dropdown .show li {
  display: block;
  white-space: nowrap;
}

.signout-dropdown ul .signout-text {
  border-top: 1px solid #eee;
  padding: 20px 0;
  user-select: none;
}
.signout-dropdown ul .signout-text p {
  padding: 0;
  font-size: 16px;
  user-select: none;
}

.signout-dropdown ul .signout-text {
  user-select: none;
}

.nav-top .list-item {
  padding: 0;
  margin: 0 45px 0 0;
  display: inline-block;
  cursor: pointer;
}

.nav-top .list-item a {
  display: inline;
}

.nav-top .list-item i {
  margin-left: 10px;
  visibility: hidden;
}

.nav-top .list-item:hover i {
  visibility: visible;
}

.nav-top .menu2-bar .list-item {
  margin: 0 75px 0 0;
  vertical-align: top;
}

.nav-top .menu2-bar .list-item.active {
  margin: 0 75px 0 0;
  border-bottom: solid 3px rgb(255, 51, 102);
  padding-bottom: 16px;
  color: #ffff;
}

.nav-top .Button__button___1FrBC {
  float: right;
  background: none;
  border: none;
  text-transform: none;
  color: #9aa4b3;
  display: inline;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}

.nav-top .Button__button___1FrBC::selection {
  background-color: transparent;
}

.nav-top ul li a.more {
  background-image: url('../assets/img/tree-dots.png');
  display: inline-block;
  width: 30px;
  height: 22px;
  background-size: 368px 13px;
  background-repeat: no-repeat;
  background-position: -4px 4px;
  cursor: pointer;
}

.toggle-list-wrapper .item.more {
  background-image: url('../assets/img/tree-dots.png');
  width: 30px;
  background-size: 368px 13px;
  background-repeat: no-repeat;
  background-position: 18px -2px;
  cursor: pointer;
}

.toggle-list-wrapper .item.more:hover {
  background-color: #fff;
}

.nav-top ul li a.more:hover {
  background-position: -62px 3px;
}
/* a.sign-out {
  position: relative;
  right: 0;
  top: 0;
} */
.toggle-list-wrapper {
  background-color: #ffff;
  position: relative;
  left: -53px;
  top: 36px;
  -webkit-box-shadow: var(--elevation-high);
  box-shadow: var(--elevation-high);
  max-width: 600px;
  overflow: scroll;
  z-index: 2;
  border-radius: 3px;
  display: inline-block;
  clear: both;
  padding: 17px 0 17px 0;
  width: 226px;
  margin-top: 127px;
  margin-top: -47px;
}

.toggle-list-wrapper .item {
  cursor: pointer;
  padding: 9px 23px;
  text-align: left;
  height: fit-content;
  margin: 0;
  font-weight: 300;
  color: #464d5d;
  font-size: 11px;
}
.toggle-list-wrapper .item.last-item {
  border-top: solid 1px #e1e4ea;
}

.toggle-list-wrapper .item:hover {
  background-color: #f0f0f0;
}

.nav-top .nav-toggle {
  float: none;
  padding: 0;
}

.nav-top .nav-toggle div {
  width: 23px;
  height: 0.7px;
  background-color: #9aa4b3;
  margin: 8px 0;
}

.nav-top .isLeftNavbarVisible .nav-toggle div {
  width: 0;
}

.nav-top .nav-toggle a:hover div {
  background-color: #fff;
}

.logo-wrapper.shift-to-left {
  margin-left: 0;
}

.logo-wrapper.shift-to-left img {
  padding-left: 0;
}

.left-topmenu-wrap {
  display: flex;
  flex-direction: column;
}
.nav-top-left-wrapper {
  display: flex;
  align-items: center;
}

.nav-top-right-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.is-active-database .nav-top-right-wrapper::before {
  position: absolute;
  content: attr(data-text);
  top: calc(100% + 15px);
  left: 0;
  font-size: 20px;
  width: 50%;
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
}
.is-active-database {
  padding-bottom: 60px;
  height: 120px;
}
.nav-top .signout-dropdown .dropdown-toggle {
  border: none;
  background: none;
}
.nav-top.signout-dropdown-close {
  z-index: 1;
}
.nav-top .signout-dropdown .btn {
  padding-right: 0 !important;
}
.nav-top .Button__button___1FrBC:hover {
  color: #686f7a;
}
.nav-top .list-item a span {
  display: inline-block;
  vertical-align: text-top;
}

.nav-top .list-item a img {
  vertical-align: middle;
}
.nav-top .nav-toggle.in-work-flow {
  display: none;
}

.nav-top .logo-wrapper.in-work-flow {
  margin-left: 0;
}
</style>
